import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import cn from 'classnames'

import { PageHeader, OptionCard, PriorityIcon } from 'components'
import { analyticsContext, useValueContext } from 'contexts'
import { defaultColor } from 'consts'
import { DictValue } from 'types'
import { useColor } from 'utils'

import './styles.scss'

export const Priority = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { taskStore, projectStore } = useValueContext()
  const color = useColor()

  const { task, setTaskField } = taskStore
  const { config } = projectStore

  const onSelect = (priority: DictValue) => {
    setTaskField('priority', priority)
    navigate(-1)
  }

  return (
    <>
      <PageHeader>{t('Приоритет')}</PageHeader>

      {config?.priorities?.map((x: any) => {
        const iconColor = x?.[color] || x?.[defaultColor]

        const onClick = () => {
          analyticsContext.trackEvent('priority_selected')
          onSelect(x)
        }

        return (
          <OptionCard
            key={x.id}
            className={cn('priority-option', { selected: x.id === task?.priority?.id })}
            before={<PriorityIcon width={14} height={14} fill={iconColor} />}
            onClick={onClick}
          >
            {t(x.title)}
          </OptionCard>
        )
      })}
    </>
  )
})
